<template>
    <div>
        <h4>Pull List</h4>
        <p v-if="orderIds && orderIds.length" class="mb-3">
            Orders: {{ orderIds.join(', ') }}
        </p>
        <div v-for="(item, index) in items" :key="index">
            <b-row>
                <b-col>
                    <order-item :item="item" :printView="true"></order-item>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import OrderItem from "./Item";

export default {
    name: "OrdersPullList",
    props: ["items", "orderIds"],
    components: { OrderItem },
};
</script>

<style scoped>
</style>

